import {
  IsArray,
  IsBoolean,
  IsEnum,
  IsInt,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsPositive,
  IsString,
} from 'class-validator'
import 'reflect-metadata'
import { AgropilotRole } from '../enums/agropilot-role.enum'
import { Length } from '../enums/length.enum'
import { Profil } from '../enums/profils.enum'
import { UserPermissions } from '../enums/user-permissions.enum'

export class SaveUserDto {
  @IsNumber()
  @IsOptional()
  id?: number

  @IsBoolean()
  @IsOptional()
  isVirtual?: boolean

  @IsString()
  @IsNotEmpty()
  email: string | undefined

  @IsNumber()
  languageId: number | undefined

  @IsString()
  @IsNotEmpty()
  defaultYieldUnit: string | undefined

  @IsString()
  @IsNotEmpty()
  defaultAreaUnit: string | undefined

  @IsString()
  @IsNotEmpty()
  defaultApplicationUnit: string | undefined

  @IsNumber()
  geolocationRadius!: number

  @IsString()
  @IsEnum(Length)
  geolocationRadiusUnit!: Length

  @IsString()
  regionName!: string

  @IsString()
  firstname!: string

  @IsString()
  lastname!: string

  @IsArray()
  @IsString({ each: true })
  availableRegions!: string[]

  @IsArray()
  @IsEnum(UserPermissions, { each: true })
  @IsOptional()
  permissions?: UserPermissions[]

  @IsNumber()
  @IsOptional()
  farmId?: number

  @IsNumber()
  @IsOptional()
  supplierId?: number

  @IsString()
  @IsOptional()
  phoneNumber?: string

  @IsString()
  @IsOptional()
  phytoCertification?: string

  @IsBoolean()
  @IsOptional()
  limitDisplay?: boolean

  @IsBoolean()
  isActive!: boolean

  @IsEnum(Profil)
  @IsNotEmpty()
  profil!: Profil

  @IsOptional()
  @IsNumber()
  reportToUserId?: number | null

  @IsEnum(AgropilotRole)
  @IsOptional()
  agropilotRole?: AgropilotRole | null

  @IsNumber()
  @IsOptional()
  campaignId?: number | null

  @IsNumber()
  @IsOptional()
  agropilotManagedReceptionSiteId?: number | null

  @IsNumber()
  @IsPositive()
  @IsInt()
  @IsOptional()
  agropilotManagedHarvesterId?: number | null

  createdBy: number | undefined
  createdAt: string | undefined
  updatedBy: number | undefined
  updatedAt: string | undefined
}
